/**
 * Bestseller PDP purchase banner
 * - Deterministic daily count in [800, 1600)
 * - Unique per bestseller slot (non-overlapping bands)
 * - Rotates at midnight IST (Asia/Kolkata)
 */
(function () {
  var root = document.querySelector('[data-bestseller-purchase-banner]');
  if (!root) return;

  var countEl = root.querySelector('[data-bestseller-purchase-count]');
  if (!countEl) return;

  var productId = String(root.dataset.productId || '');
  var productIndex = parseInt(root.dataset.productIndex, 10);
  if (!productId || isNaN(productIndex) || productIndex < 0 || productIndex > 9) return;

  var MIN = parseInt(root.dataset.min, 10) || 800;
  var MAX = parseInt(root.dataset.max, 10) || 1600;
  var BAND = Math.floor((MAX - MIN) / 10); // 80 when 800..1600

  function istDateKey() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
    } catch (e) {
      var d = new Date();
      return d.toISOString().slice(0, 10);
    }
  }

  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function dailyPurchaseCount(id, index, dateKey) {
    var seed = hash(dateKey + ':ayudra-bestseller-purchases:' + id);
    var jitter = seed % BAND;
    return MIN + index * BAND + jitter;
  }

  function render() {
    var dateKey = istDateKey();
    var count = dailyPurchaseCount(productId, productIndex, dateKey);
    countEl.textContent = count.toLocaleString('en-IN');
  }

  render();

  /* Refresh shortly after IST midnight if the tab stays open */
  setInterval(render, 60 * 1000);
})();
